import * as React from 'react';
import * as SeparatorPrimitive from '@radix-ui/react-separator';

// Closed thin-line divider. Either horizontal (default — full-width 1px
// row) or vertical (full-height 1px column). Caller passes orientation
// only; everything else (paint, decorative aria semantics) is baked.

const HORIZONTAL_CLASSNAME = 'tw-h-px tw-w-full tw-shrink-0 tw-bg-border';
const VERTICAL_CLASSNAME = 'tw-h-full tw-w-px tw-shrink-0 tw-bg-border';

const Separator = React.forwardRef(({ className: _className, style: _style, orientation = 'horizontal' }, ref) => (
    <SeparatorPrimitive.Root
        ref={ref}
        className={orientation === 'horizontal' ? HORIZONTAL_CLASSNAME : VERTICAL_CLASSNAME}
        decorative
        orientation={orientation}
    />
));

Separator.displayName = 'Separator';

export { Separator };
